import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/auth/service';

import { AuthenticationService } from 'app/auth/service';
import { User } from 'app/auth/models';

@Component({
  selector: 'app-header-user',
  templateUrl: './header-user.component.html',
  styleUrls: ['./header-user.component.scss'],
})
export class HeaderUserComponent implements OnInit {
  nomeUser: string;
  emailUser: string;
  escolha: any;
  escolha1: any;
  escolha2: any;
  Value: any;
  botao: any;
  imagemEscolha = 'assets/images/icons/brasil.svg';
  paisEscolha = 'PORTUGUÊS';

  imgs_ = [
    'assets/images/icons/brasil.svg',
    'assets/images/icons/estados-unidos-da-america 1.svg',
    'assets/images/icons/espanha 1.svg',
  ];

  public currentUser: User;

  constructor(
    private dados: UserService,
    public authService: AuthenticationService
  ) {
    this.authService.currentUser.subscribe(x => (this.currentUser = x));
  }

  ngOnInit(): void {
    this.nomeUser = this.dados.user;
    this.emailUser = this.dados.email;
  }
  customizeButton(valor) {
    if (valor == 'escolha') {
      this.imagemEscolha = this.imgs_[0];
      this.paisEscolha = 'PORTUGUÊS';
    }
    if (valor == 'escolha1') {
      this.imagemEscolha = this.imgs_[1];
      this.paisEscolha = 'ENGLISH';
    }
    if (valor == 'escolha2') {
      this.imagemEscolha = this.imgs_[2];
      this.paisEscolha = 'ESPAÑOL';
    }
  }
  passValue($event, valor) {
    this.Value = valor;

    this.customizeButton(this.Value);
  }
}

